@if (items.length > 0) {
  <div class="h-full flex flex-col">
    <div class="h-48 p-2 flex justify-between items-center bg-white shadow">
      <div class="flex items-center gap-2 pl-3">
        <dg-breadcrumb-list (action)="onBreadcrumb($event)" [breadcrumbs]="breadcrumbs"></dg-breadcrumb-list>
      </div>
      <dg-record-toolbar
        (changeViewMode)="onChangeRecordViewMode($event)"
        [activeViewMode]="viewMode$ | async"
      ></dg-record-toolbar>
    </div>
    <div class="flex-auto overflow-auto">
      <dg-record-list
        [activeRecordId]="activeRecordId$ | async"
        [collectionLabel]="collectionLabel"
        [items]="items"
        [viewMode]="viewMode$ | async"
        [pagination]="pagination"
      ></dg-record-list>
    </div>
    @if (pagination && pagination.links.length > 0) {
      <div class="p-2 bg-white border-top">
        <dg-record-pagination (pageChange)="onPaginationLink($event)" [pagination]="pagination"></dg-record-pagination>
      </div>
    }
  </div>
}
